module.exports = __webpack_public_path__ + "static/img/ig.3530f8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/ig.png
// module id = Wm6x
// module chunks = 1